(function () {
  'use strict';

  /* ── Money formatting ── */
  var ZERO_DECIMAL = { BIF:1,CLP:1,DJF:1,GNF:1,ISK:1,JPY:1,KMF:1,KRW:1,MGA:1,PYG:1,RWF:1,UGX:1,VND:1,VUV:1,XAF:1,XOF:1,XPF:1 };

  function formatCents(cents, thou, dec, prec, divisor) {
    var num   = (cents / divisor).toFixed(prec);
    var parts = num.split('.');
    var whole = (parts[0] || '0').replace(/\d(?=(\d{3})+(?!\d))/g, function (d) { return d + thou; });
    return prec === 0 ? whole : whole + dec + (parts[1] || '').padEnd(prec, '0');
  }

  function formatMoney(cents, format, currency) {
    currency = (currency || 'USD').toUpperCase();
    format   = format || '${{amount}}';
    var prec0   = ZERO_DECIMAL[currency] ? 0 : 2;
    var divisor = Math.pow(10, prec0);
    return format.replace(/{{\s*(\w+)\s*}}/g, function (_, key) {
      var thou = ',', dec = '.', prec = prec0;
      switch (key) {
        case 'amount': break;
        case 'amount_no_decimals': prec = 0; break;
        case 'amount_with_comma_separator': thou = '.'; dec = ','; break;
        case 'amount_no_decimals_with_comma_separator': thou = '.'; prec = 0; break;
        case 'amount_with_space_separator': thou = ' '; dec = ','; break;
        case 'amount_no_decimals_with_space_separator': thou = ' '; prec = 0; break;
        case 'amount_with_apostrophe_separator': thou = "'"; break;
        default: return key === 'currency' ? currency : '';
      }
      return formatCents(cents, thou, dec, prec, divisor);
    });
  }

  /* ── Empty-slot placeholder SVG ── */
  var EMPTY_THUMB_SVG = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">'
    + '<circle cx="11" cy="11" r="10" stroke="#C9956C" stroke-width="1.5" stroke-dasharray="4 3"/>'
    + '<path d="M11 7v8M7 11h8" stroke="#C9956C" stroke-width="1.5" stroke-linecap="round"/>'
    + '</svg>';

  var ADD_BTN_INNER = '<span class="nf-db__btn-default">'
    + '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">'
    + '<path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
    + '</svg>Add to Bundle</span>'
    + '<span class="nf-db__btn-full" hidden>Bundle Full</span>';

  /* ── BundleBuilder ── */
  function BundleBuilder(cfg) {
    this.cfg   = cfg;
    this.slots = new Array(cfg.bundleCount).fill(null);
    this.init();
  }

  BundleBuilder.prototype.init = function () {
    var sid = this.cfg.sid;
    this.$section = document.getElementById('nf-db-' + sid);
    this.$slots   = document.getElementById('nf-db-slots-'  + sid);
    this.$fill    = document.getElementById('nf-db-fill-'   + sid);
    this.$prog    = document.getElementById('nf-db-prog-'   + sid);
    this.$cta     = document.getElementById('nf-db-cta-'    + sid);
    this.$hint    = document.getElementById('nf-db-hint-'   + sid);
    this.$reg     = document.getElementById('nf-db-reg-'    + sid);
    this.$save    = document.getElementById('nf-db-save-'   + sid);
    this.$total   = document.getElementById('nf-db-total-'  + sid);
    this.$mfill   = document.getElementById('nf-db-mfill-'  + sid);
    this.$mprog   = document.getElementById('nf-db-mprog-'  + sid);
    this.$mcta    = document.getElementById('nf-db-mcta-'   + sid);

    /* Restore add-button inner HTML (Liquid renders plain text, JS manages state) */
    this.$section.querySelectorAll('.nf-db__add-btn').forEach(function (btn) {
      if (!btn.dataset.available || btn.dataset.available === 'false') return;
      btn.innerHTML = ADD_BTN_INNER;
    });

    this.bindEvents();
    this.updateBundleImage(0);
  };

  BundleBuilder.prototype.bindEvents = function () {
    var self = this;

    /* Add-to-bundle clicks */
    this.$section.addEventListener('click', function (e) {
      var btn = e.target.closest('.nf-db__add-btn');
      if (!btn || btn.disabled) return;
      if (btn.dataset.available === 'false') return;
      var count = self.slots.filter(Boolean).length;
      if (count >= self.cfg.bundleCount) return;
      self.addItem({
        variantId: parseInt(btn.dataset.variantId, 10),
        title:     btn.dataset.title,
        price:     parseInt(btn.dataset.price, 10),
        image:     btn.dataset.image || ''
      });
    });

    /* Remove-slot clicks */
    if (this.$slots) {
      this.$slots.addEventListener('click', function (e) {
        var btn = e.target.closest('.nf-db__slot-remove');
        if (!btn) return;
        var slot = btn.closest('.nf-db__slot');
        if (!slot) return;
        self.removeItem(parseInt(slot.dataset.index, 10));
      });
    }

    /* Desktop CTA */
    if (this.$cta) {
      this.$cta.addEventListener('click', function () { self.addToCart(); });
    }

    /* Mobile CTA */
    if (this.$mcta) {
      this.$mcta.addEventListener('click', function () { self.addToCart(); });
    }

    /* Touch preview: show second image on press, revert on lift/scroll */
    this.$section.querySelectorAll('.nf-db__card').forEach(function (card) {
      var media = card.querySelector('.nf-db__card-media');
      if (!media || !card.querySelector('.nf-db__card-img--secondary')) return;
      media.addEventListener('touchstart', function () {
        card.classList.add('nf-db--touch-preview');
      }, { passive: true });
      media.addEventListener('touchmove', function () {
        card.classList.remove('nf-db--touch-preview');
      }, { passive: true });
      media.addEventListener('touchend', function () {
        card.classList.remove('nf-db--touch-preview');
      }, { passive: true });
      media.addEventListener('touchcancel', function () {
        card.classList.remove('nf-db--touch-preview');
      }, { passive: true });
    });
  };

  BundleBuilder.prototype.addItem = function (item) {
    var idx = this.slots.indexOf(null);
    if (idx === -1) return;
    this.slots[idx] = item;
    this.updateUI();
  };

  BundleBuilder.prototype.removeItem = function (idx) {
    this.slots[idx] = null;
    /* Compact left so empty slots are always at the end */
    var filled = this.slots.filter(Boolean);
    this.slots = filled.concat(new Array(this.cfg.bundleCount - filled.length).fill(null));
    this.updateUI();
  };

  BundleBuilder.prototype.updateUI = function () {
    var self    = this;
    var cfg     = this.cfg;
    var total   = cfg.bundleCount;
    var count   = this.slots.filter(Boolean).length;
    var pct     = Math.round((count / total) * 100);
    var isFull  = count >= total;
    var isDone  = count === total;

    /* Progress bars & labels */
    var progText = count + '/' + total + ' Selected';
    if (this.$fill)  this.$fill.style.width   = pct + '%';
    if (this.$prog)  this.$prog.textContent    = progText;
    if (this.$mfill) this.$mfill.style.width   = pct + '%';
    if (this.$mprog) this.$mprog.textContent   = progText;

    /* Slot elements */
    var slotEls = this.$slots ? this.$slots.querySelectorAll('.nf-db__slot') : [];
    slotEls.forEach(function (el, i) {
      var item   = self.slots[i];
      var thumb  = el.querySelector('.nf-db__slot-thumb');
      var name   = el.querySelector('.nf-db__slot-name');
      var rmBtn  = el.querySelector('.nf-db__slot-remove');

      if (item) {
        el.classList.remove('nf-db__slot--empty');
        el.classList.add('nf-db__slot--filled');
        if (thumb) {
          thumb.innerHTML = item.image
            ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">'
            : EMPTY_THUMB_SVG;
        }
        if (name)  name.textContent = item.title;
        if (rmBtn) rmBtn.hidden = false;
      } else {
        el.classList.add('nf-db__slot--empty');
        el.classList.remove('nf-db__slot--filled');
        if (thumb) thumb.innerHTML = EMPTY_THUMB_SVG;
        if (name)  name.textContent = 'Choose a flavor';
        if (rmBtn) rmBtn.hidden = true;
      }
    });

    /* Add-to-bundle button states */
    this.$section.querySelectorAll('.nf-db__add-btn').forEach(function (btn) {
      if (!btn.querySelector('.nf-db__btn-default')) return; // out-of-stock (plain text)
      var dflt = btn.querySelector('.nf-db__btn-default');
      var full = btn.querySelector('.nf-db__btn-full');
      if (isFull) {
        dflt.hidden = true;
        full.hidden = false;
        btn.classList.add('nf-db__add-btn--full');
      } else {
        dflt.hidden = false;
        full.hidden = true;
        btn.classList.remove('nf-db__add-btn--full');
      }
    });

    /* Pricing */
    var filled       = this.slots.filter(Boolean);
    var regularTotal = filled.reduce(function (s, x) { return s + x.price; }, 0);
    var discountAmt  = 0;

    if (isDone && cfg.discountValue > 0) {
      discountAmt = cfg.discountType === 'percentage'
        ? Math.round(regularTotal * cfg.discountValue / 100)
        : Math.round(cfg.discountValue * 100);
    }

    var bundleTotal = regularTotal - discountAmt;
    var fmt = cfg.moneyFormat;
    var cur = cfg.currency;

    if (this.$reg)   this.$reg.textContent   = filled.length ? formatMoney(regularTotal, fmt, cur) : '—';
    if (this.$total) this.$total.textContent = filled.length ? formatMoney(bundleTotal,  fmt, cur) : '—';
    if (this.$save) {
      if (discountAmt > 0) {
        this.$save.textContent = '− ' + formatMoney(discountAmt, fmt, cur);
        this.$save.classList.add('nf-db__save--active');
      } else {
        this.$save.textContent = '—';
        this.$save.classList.remove('nf-db__save--active');
      }
    }

    /* CTA buttons */
    [this.$cta, this.$mcta].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !isDone;
      btn.setAttribute('aria-disabled', isDone ? 'false' : 'true');
      /* Keep button label text only (not SVG) — set via textContent safely */
      btn.textContent = isDone ? cfg.ctaActive : cfg.ctaInactive;
    });

    /* Hint text */
    if (this.$hint) {
      if (isDone) {
        this.$hint.textContent = '✓ Bundle complete! Click to add to cart.';
        this.$hint.classList.add('nf-db__hint--done');
      } else {
        var rem = total - count;
        this.$hint.textContent = 'Select ' + rem + ' more flavor' + (rem === 1 ? '' : 's') + ' to complete your bundle';
        this.$hint.classList.remove('nf-db__hint--done');
      }
    }

    /* Bundle image blur reveal */
    this.updateBundleImage(count);
  };

  BundleBuilder.prototype.updateBundleImage = function (count) {
    var wrap = document.getElementById('nf-db-bundle-img-' + this.cfg.sid);
    if (!wrap) return;
    var img = wrap.querySelector('.nf-db__bundle-img');
    if (!img) return;

    var blurEnabled  = wrap.dataset.blurEnabled === 'true';
    var total        = parseInt(wrap.dataset.bundleCount, 10) || this.cfg.bundleCount;
    var progress     = total > 0 ? Math.min(count / total, 1) : 1;

    if (blurEnabled) {
      var maxBlur      = parseFloat(wrap.dataset.maxBlur)         || 12;
      var minBlur      = parseFloat(wrap.dataset.minBlur)         || 0;
      var startOpacity = parseFloat(wrap.dataset.startOpacity)    || 0.45;
      var endOpacity   = parseFloat(wrap.dataset.endOpacity)      || 1;
      var brightStart  = parseFloat(wrap.dataset.brightnessStart) || 80;
      var brightEnd    = parseFloat(wrap.dataset.brightnessEnd)   || 100;

      var blur       = maxBlur - (maxBlur - minBlur) * progress;
      var opacity    = startOpacity + (endOpacity - startOpacity) * progress;
      var brightness = brightStart + (brightEnd - brightStart) * progress;

      img.style.filter  = 'blur(' + blur.toFixed(1) + 'px) brightness(' + brightness.toFixed(0) + '%)';
      img.style.opacity = opacity.toFixed(3);
    } else {
      img.style.filter  = '';
      img.style.opacity = '';
    }
  };

  BundleBuilder.prototype.addToCart = function () {
    var self   = this;
    var cfg    = this.cfg;
    var filled = this.slots.filter(Boolean);
    if (filled.length !== cfg.bundleCount) return;

    var bundleId = 'nf-bundle-' + Date.now();
    var items = filled.map(function (item, i) {
      return {
        id:         item.variantId,
        quantity:   1,
        properties: {
          '_bundle':     cfg.bundleName,
          '_bundle_id':  bundleId,
          '_flavor_slot': (i + 1) + ' of ' + cfg.bundleCount
        }
      };
    });

    /* Loading state */
    [this.$cta, this.$mcta].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = true;
      btn.textContent = 'Adding to cart…';
    });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart_add_failed');
      return res.json();
    })
    .then(function () {
      /* Apply discount code via API (if configured), then get updated cart */
      if (cfg.discountCode) {
        return fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ discount: cfg.discountCode })
        }).then(function (r) { return r.json(); });
      }
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      /* Open cart drawer by dispatching the theme's cart:update event */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: { itemCount: cart.item_count }
        }
      }));
      [self.$cta, self.$mcta].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = cfg.ctaActive;
      });
    })
    .catch(function () {
      [self.$cta, self.$mcta].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = cfg.ctaActive;
      });
      if (self.$hint) {
        self.$hint.textContent = 'Something went wrong — please try again.';
        self.$hint.style.color = '#c0392b';
      }
    });
  };

  /* ── Bootstrap ── */
  function init() {
    var configs = window.nfDubaiBundle || {};
    Object.keys(configs).forEach(function (sid) {
      var cfg = configs[sid];
      var el  = document.getElementById('nf-db-' + sid);
      if (el && !el._nfDbReady) {
        el._nfDbReady = true;
        new BundleBuilder(cfg);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
